import { SsoProvidersServiceInterface } from 'domain/services';
import { GetAllSsoProvidersUseCaseInterface } from 'domain/usecases';

interface UseCasesInjection {
  getAllSsoProviders: GetAllSsoProvidersUseCaseInterface;
}

export class SsoProvidersService implements SsoProvidersServiceInterface {
  private readonly _getAllSsoProviders: GetAllSsoProvidersUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllSsoProviders = usecases.getAllSsoProviders;
  }

  getAllSsoProviders(): Promise<GetAllSsoProvidersUseCaseInterface.Result> {
    return this._getAllSsoProviders.execute();
  }
}
